import { Component, EventEmitter, Output, effect, inject } from '@angular/core';
import { FinishesSubStep } from './models/finishes-sub-step.enum';
import { FinishesSubStepService } from './services/finishes-sub-step.service';

@Component({
  selector: 'ng-closet-doors-standard-finishes',
  templateUrl: './finishes.component.html',
  styleUrls: ['./finishes.component.scss'],
  providers: [FinishesSubStepService],
})
export class ClosetDoorsStandardFinishesComponent {
  /**
   * Émis à chaque changement de sous-étape active (ouverture/fermeture d'une carte).
   * Le composant parent le relaie via `getFinishesStep` pour que le composant de preview
   * sache quelle section est ouverte et puisse ajuster son rendu en conséquence.
   * Valeurs : voir {@link FinishesSubStep}.
   */
  @Output() onSubStepChange: EventEmitter<FinishesSubStep> = new EventEmitter<FinishesSubStep>();

  private readonly subStepService = inject(FinishesSubStepService);

  constructor() {
    effect(() => this.onSubStepChange.emit(this.subStepService.subStep()));
  }
}
